<template>
	<div v-if="products">
		<div class="selection-bar">
			<div class="form_check">
				<input ref="selectAllInput" type="checkbox" :id="'select-all-products-' + orderID" @click="selectAll" />
				<span class="checkmark" @click="$refs.selectAllInput.click()"></span>
				<label
					:for="'select-all-products-' + orderID"
					v-text="selected.length === products.length ? 'ביטול בחירה' : 'בחירת כל המוצרים'"
				></label>
			</div>
			<div>
				<div v-if="selected.length">נבחרו {{ selected.length }} מוצרים</div>
			</div>
		</div>
		<div class="order-products">
			<template v-if="$mq === 'desktop'">
				<div class="right order_col_in" v-for="(column, index) in productsList" :key="index">
					<Product
						v-for="product in column"
						:product="product"
						:selected="selected.includes(product.id)"
						:key="product.id"
						@select="select"
					/>
				</div>
			</template>
			<div class="order_col_in" v-else>
				<Product
					v-for="product in products"
					:product="product"
					:selected="selected.includes(product.id)"
					:key="product.id"
					@select="select"
				/>
			</div>
		</div>
	</div>
</template>

<script>
	import Product from "./TableProduct.vue";

	export default {
		props: ["products", "orderID"],
		data() {
			return {
				productsList: "",
				selected: [],
				selectedAll: false,
			};
		},
		mounted() {
			this.productsList = this.products;
			if (this.$mq !== "mobile") {
				this.productsList = this.chunkify(this.productsList, 3, true);
			}
		},
		watch: {
			selected(value) {
				this.$emit("select", value);
			},
		},
		methods: {
			selectAll() {
				this.selectedAll = !this.selectedAll;
				if (this.selectedAll) {
					this.selected = [];
				}
				this.products.map((product) => {
					const index = this.selected.indexOf(product.id);
					if (index !== -1) {
						this.selected.splice(index, 1);
					} else {
						this.selected.push(product.id);
					}
				});
			},
			select(product_id) {
				const index = this.selected.indexOf(product_id);
				console.log("index", index);
				if (index !== -1) {
					this.selected.splice(index, 1);
				} else {
					this.selected.push(product_id);
				}
			},
			chunkify(a, n, balanced) {
				if (n < 2) return [a];

				var len = a.length,
					out = [],
					i = 0,
					size;

				if (len % n === 0) {
					size = Math.floor(len / n);
					while (i < len) {
						out.push(a.slice(i, (i += size)));
					}
				} else if (balanced) {
					while (i < len) {
						size = Math.ceil((len - i) / n--);
						out.push(a.slice(i, (i += size)));
					}
				} else {
					n--;
					size = Math.floor(len / n);
					if (len % size === 0) size--;
					while (i < size * n) {
						out.push(a.slice(i, (i += size)));
					}
					out.push(a.slice(size * n));
				}
				return out;
			},
		},
		components: {
			Product,
		},
	};
</script>

<style lang="sass" scoped>
	.selection-bar
	  display: flex
	  justify-content: space-between
	  padding: 10px 16px
	  background: #efede9

	  label
	    margin: 0
	    font-weight: normal

	  input
	    margin-left: 8px
	    vertical-align: text-top
	    accent-color: #1e824c

	.order-products
	  padding: 20px 0 15px
	  display: inline-block

	  .order_col_in
	    width: 33%
	    padding-right: 15px

	.form_check
	  padding-right: 27px
	  margin: 0
	  font-size: inherit

	  .checkmark
	    background-color: #fff


	@media (max-width: 800px)
	  .order-products
	    max-height: none
	    overflow: hidden

	    .order_col_in
	      width: 100%

	  .selection-bar
	    margin-top: 15px
</style>
